import { useRouter, useRuntimeConfig } from '#imports'
import * as Sentry from '@sentry/nuxt'

declare const APP_NAME: string
declare const APP_VERSION: string

const config = useRuntimeConfig()

if (config.public.sentryDsn) {
  Sentry.init({
    dsn: config.public.sentryDsn,
    environment: config.app.ENVIRONMENT,
    release: `${APP_NAME}@${APP_VERSION}`,
    integrations: [
      Sentry.browserTracingIntegration({ router: useRouter() }),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: 1.0,
  })
}
